jQuery(document).ready(function ($) {
  if ($('body').hasClass('page-template-ocrolus-2024')) {
    const chart2024Q1Median = document.getElementById('2024-q1-median');

    new Chart(chart2024Q1Median, {
      type: 'line',
      data: {
        labels: ['Apr \'23', 'May \'23', 'Jun \'23', 'Jul \'23', 'Aug \'23', 'Sep \'23', 'Oct \'23', 'Nov \'23', 'Dec \'23', 'Jan \'24', 'Feb \'24', 'Mar \'24'],
        datasets: [{
          label: 'Median Revenue by Month',
          data: ['50985', '57015', '55967', '54511', '59658.5', '56485', '62358', '59363.5', '58412', '56592', '53496', '50651.5'],
          borderColor: '#0064dd',
        }]
      },
      options: {
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(context.parsed.y);
                }
                return label;
              }
            }
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Months',
            },
            grid: {
              color: '#fff',
              tickLength: -6,
            },
            ticks: {
              maxRotation: 45,
              minRotation: 45
            },
          },
          y: {
            border: { display: false },
            title: {
              display: true,
              text: 'Revenue',
            },
            ticks: {
              stepSize: 5000,
              callback: function (value, index, ticks) {
                return '$' + Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]);
              }
            },
            min: 45000,
            max: 65000,
          }
        }
      }
    });

    const chart2024Q1PayToRev = document.getElementById('2024-q1-paytorev');

    new Chart(chart2024Q1PayToRev, {
      type: 'line',
      data: {
        labels: ['Apr \'23', 'May \'23', 'Jun \'23', 'Jul \'23', 'Aug \'23', 'Sep \'23', 'Oct \'23', 'Nov \'23', 'Dec \'23', 'Jan \'24', 'Feb \'24', 'Mar \'24'],
        datasets: [{
          label: 'Payroll-to-Revenue Ratio',
          data: ['18.70', '17.34', '19.42', '17.50', '18.56', '19.44', '17.74', '20.10', '20.50', '18.25', '20.18', '19.93'],
          borderColor: '#0064dd',
        }]
      },
      options: {
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += context.parsed.y + '%';
                }
                return label;
              }
            }
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Months',
            },
            grid: {
              color: '#fff',
              tickLength: -6,
            },
            ticks: {
              maxRotation: 45,
              minRotation: 45
            },
          },
          y: {
            border: { display: false },
            title: {
              display: true,
              text: 'Ratio',
            },
            ticks: {
              stepSize: 2,
              callback: function (value, index, ticks) {
                return Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]) + '%';
              }
            },
            min: 16,
            max: 22,
          }
        }
      }
    });

    const chart2024Q1FutureGrowth = document.getElementById('2024-q1-futuregrowth');

    new Chart(chart2024Q1FutureGrowth, {
      type: 'bar',
      data: {
        labels: ['Q4 2023', 'Q4 2024'],
        datasets: [{
          label: 'Significant Growth',
          data: ['25.8', '30.8'],
          backgroundColor: '#0064dd',
          borderColor: '#0064dd',
        },
        {
          label: 'Moderate Growth',
          data: ['65.8', '61.8'],
          backgroundColor: '#000082',
          borderColor: '#000082',
        },
        {
          label: 'No Growth',
          data: ['8.4', '7.3'],
          backgroundColor: '#83dcc1',
          borderColor: '#83dcc1',
        }]
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += context.parsed.y + '%';
                }
                return label;
              }
            }
          },
        },
        scales: {
          x: {
            grid: { display: false },
          },
          y: {
            border: { display: false },
            ticks: {
              stepSize: 10,
              callback: function (value, index, ticks) {
                return Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]) + '%';
              }
            },
            max: 70,
          }
        }
      }
    });

    const chart2024Q1RevToExp = document.getElementById('2024-q1-revtoexp');

    new Chart(chart2024Q1RevToExp, {
      type: 'line',
      data: {
        labels: ['Apr \'23', 'May \'23', 'Jun \'23', 'Jul \'23', 'Aug \'23', 'Sep \'23', 'Oct \'23', 'Nov \'23', 'Dec \'23', 'Jan \'24', 'Feb \'24', 'Mar \'24'],
        datasets: [{
          label: 'Boston only',
          data: ['100.73', '102.24', '101.51', '101.67', '99.76', '99.60', '100.85', '99.77', '99.75', '98.94', '100.12', '100.81'],
          borderColor: '#83dcc1',
          backgroundColor: '#83dcc1',
          pointBackgroundColor: '#83dcc1',
        },
        {
          label: 'Dallas only',
          data: ['99.39', '100.44', '99.92', '99.56', '99.41', '99.13', '100.00', '99.71', '99.76', '100.06', '100.34', '99.59'],
          borderColor: '#000082',
          backgroundColor: '#000082',
          pointBackgroundColor: '#000082',
        },
        {
          label: 'U.S.',
          data: ['99.73', '100.78', '100.03', '100.18', '99.77', '99.34', '100.47', '99.64', '99.81', '100.00', '100.23', '100.19'],
          borderColor: '#0064dd',
          backgroundColor: '#0064dd',
          pointBackgroundColor: '#0064dd',
        }]
      },
      options: {
        plugins: {
          legend: { reverse: true },
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label.replace(/ only/g, '') || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += context.parsed.y + '%';
                }
                return label;
              }
            }
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Months',
            },
            grid: {
              color: '#fff',
              tickLength: -6,
            },
            ticks: {
              maxRotation: 45,
              minRotation: 45
            },
          },
          y: {
            border: { display: false },
            title: {
              display: true,
              text: 'Ratio',
            },
            ticks: {
              stepSize: 2,
              callback: function (value, index, ticks) {
                return Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]) + '%';
              }
            },
            min: 95,
            max: 105,
          }
        }
      }
    });
  }
});
